import router from "./router"; //导入路由文件
import store from './store'; //导入全局变量
import { getPageTitle } from "./utils"; //页面标题 
import Auth from "./utils/auth"; //身份验证

import Loading from "./utils/Loading"; //获取加载组件

//全局路由守卫
router.beforeEach((to,from,next) => {
	//to = 当前点击路由的相关信息
	//获取当前点击路径 to.path
	//from = 当前将要离开路由相关信息
	//next规则如下：
	//在守卫方法中如果不声明next形参，则默认允许用户访问每一个路由。
	//在守卫方法中如果声明了next形参，则必须调用next()函数，否则不允许用户访问任何一个路由。
	//next() = 放行
	//next(false) = 强制停留当前页
	//next('') = 强制用户跳转至指定页面
	
	// Loading.LoadingShow();
	
    // 页面标题
    document.title = getPageTitle(to.meta.title);

	next();

	// Loading.LoadingHide();
})